import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/open-link.svg";
var OpenLinkOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  OpenLinkOutline_default as default
};
